var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"adminNav"},[_c('p',{staticClass:"title"},[_vm._v("Base de données")]),_c('ul',_vm._l((_vm.navigations),function(page,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":{ name: page.viewName }}},[_vm._v(_vm._s(page.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }